import { SxProps } from '@mui/material'

interface RadioIconStyles {
  radioIcon: SxProps
  radioCheckedIcon: SxProps
}

export const radioIconStyles: RadioIconStyles = {
  radioIcon: {
    borderRadius: '50%',
    width: 16,
    height: 16,
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'border.primary',
    '.Mui-focusVisible &': {
      outline: '2px auto',
      outlineColor: 'border.primary',
      outlineOffset: 2,
    },
    'input:hover ~ &': {
      borderColor: 'brand.primary600',
    },
    'input:disabled ~ &': {
      backgroundColor: 'utils.gray50',
      borderColor: 'border.primary',
    },
  },
  radioCheckedIcon: {
    backgroundColor: 'background.default',
    borderWidth: 5,
    borderColor: 'brand.primary600',

    'input:disabled ~ &': {
      borderColor: 'border.primary',
    },
  },
}
